export const NAME = 'products';
